import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from 'src/icons/untitled-ui/free/push';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import vi from 'date-fns/locale/vi';

const viewOptions = [
  {
    label: 'Theo tháng',
    value: 'dayGridMonth',
  },
  {
    label: 'Đã đăng ký',
    value: 'listMonth',
  },
];

export const CalendarToolbar = (props) => {
  const {
    date,
    onAddClick,
    onDateNext,
    onDatePrev,
    onViewChange,
    view,
    ...other
  } = props;
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));

  const handleViewChange = useCallback(
    (event) => {
      onViewChange?.(event.target.value);
    },
    [onViewChange],
  );

  const dateMonth = format(date, 'MMMM', { locale: vi });

  // On mobile, we allow the same view options since we only have two options
  const availableViewOptions = useMemo(() => viewOptions, []);

  return (
    <Stack
      alignItems="center"
      flexWrap="wrap"
      justifyContent="space-between"
      flexDirection={{
        xs: 'column',
        md: 'row',
      }}
      spacing={3}
      sx={{ px: 3 }}
      {...other}
    >
      <Stack alignItems="center" direction="row" spacing={1}>
        <Typography variant="h5">{dateMonth}</Typography>
      </Stack>
      <Stack alignItems="center" direction="row" spacing={1}>
        <IconButton onClick={onDatePrev}>
          <SvgIcon>
            <ChevronLeftIcon />
          </SvgIcon>
        </IconButton>
        <IconButton onClick={onDateNext}>
          <SvgIcon>
            <ChevronRightIcon />
          </SvgIcon>
        </IconButton>
        <TextField
          label="Chọn"
          name="view"
          onChange={handleViewChange}
          select
          SelectProps={{ native: true }}
          size="small"
          sx={{
            minWidth: 120,
            order: {
              xs: -1,
              md: 0,
            },
          }}
          value={view}
        >
          {availableViewOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
        <Button
          onClick={onAddClick}
          startIcon={
            <SvgIcon>
              <AddIcon />
            </SvgIcon>
          }
          sx={{
            width: {
              xs: '100%',
              md: 'auto',
            },
          }}
          variant="contained"
        >
          New Event
        </Button>
      </Stack>
    </Stack>
  );
};

CalendarToolbar.propTypes = {
  children: PropTypes.node,
  date: PropTypes.instanceOf(Date).isRequired,
  onAddClick: PropTypes.func,
  onDateNext: PropTypes.func,
  onDatePrev: PropTypes.func,
  onViewChange: PropTypes.func,
  view: PropTypes.oneOf(['dayGridMonth', 'listMonth']).isRequired,
};
